import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Select', {
    ref: "buscarCliente",
    attrs: {
      "placeholder": "Informe o Nome/CPF/CNPJ",
      "labelBusca": "name",
      "inputClass": "busca-cliente",
      "label": _vm.label,
      "value": _vm.client,
      "options": _vm.clients,
      "change": _vm.change,
      "search": _vm.searchCliente,
      "disabled": _vm.disabled
    },
    scopedSlots: _vm._u([{
      key: "options",
      fn: function fn(props) {
        return [_c('div', {
          staticClass: "selected",
          staticStyle: {
            "text-transform": "uppercase"
          }
        }, [_vm._v(" " + _vm._s(props.data.name) + " "), _c('br'), _vm._v(" CPF/CNPJ " + _vm._s(props.data.identification) + " ")])];
      }
    }])
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };